import { render, staticRenderFns } from "./WhyChooseUsListing.vue?vue&type=template&id=a2bfcf5c&"
import script from "./WhyChooseUsListing.vue?vue&type=script&lang=js&"
export * from "./WhyChooseUsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports